import { Search, Settings, Rocket, LineChart } from "lucide-react";
import { Container } from "@/shared/components/Container";
import { SectionTag } from "@/shared/components/SectionTag";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { MethodStep } from "@/shared/components/MethodStep";
import { Reveal } from "@/shared/components/Reveal";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Method.module.css";

const STEP_ICONS: Record<string, React.ReactNode> = {
  Search: <Search size={36} />,
  Settings: <Settings size={36} />,
  Rocket: <Rocket size={36} />,
  LineChart: <LineChart size={36} />,
};

export function Method() {
  const locale = useLocale();
  const content = getHomeContent(locale);

  return (
    <section id="metodo" className={styles.method}>
      <Container>
        <div className={styles.header}>
          <Reveal>
            <SectionTag>{content.method.tag}</SectionTag>
          </Reveal>
          <Reveal delay={80} className={styles.titleReveal}>
            <GradientHeading className={styles.title}>
              {content.method.title}
            </GradientHeading>
          </Reveal>
          <Reveal as="p" className={styles.subtitle} delay={140}>
            {content.method.subtitle}
          </Reveal>
        </div>

        <div className={styles.stage}>
          <div className={styles.steps}>
            {content.method.steps.map((step, index) => (
              <Reveal
                key={step.title}
                className={styles.stepReveal}
                delay={index * 90}
              >
                <MethodStep
                  icon={STEP_ICONS[step.iconName] ?? <Search size={36} />}
                  title={step.title}
                  description={step.description}
                />
              </Reveal>
            ))}
          </div>

          <hr className={styles.divider} />

          <Reveal className={styles.powered} delay={120}>
            <span className={styles.poweredLabel}>{content.method.poweredLabel}</span>
            <img
              className={styles.poweredLogo}
              src="/assets/logo-aura.svg"
              alt="Aura"
              width={182}
              height={46}
              loading="lazy"
            />
            <p className={styles.poweredText}>
              {content.method.poweredText}
              <span className={styles.accent}>
                {content.method.poweredAccent}
              </span>
            </p>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
